module.exports = __webpack_public_path__ + "static/media/globe-snow.e8b147ec.svg";